<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailProduitReseau.facesAssociesReseau')}}
      </p>
    </header>
    <div class="mg-4">
      <app-information-msg-component :title="$t('detailProduitReseau.infoFacesAssociesReseau')"
                                    :libelleList="getMessagesInfo">
      </app-information-msg-component>
    </div>
    <div class="card-content">
      <div class="columns level">
        <div class="level-left">
          <form @submit.prevent.stop="filter = filterInput"  class="column is-9">
            <div class="field has-addons">
              <div class="control inputSearch has-icons-left is-clearfix">
                <b-input :placeholder="$t('catalogue.actions.searchFace')"
                         v-model="filterInput" type="search">
                </b-input>
                <b-icon class="icon is-left"
                        icon="magnify"></b-icon>
              </div>
              <p class="control">
                <button class="button is-primary"
                        type="submit">
                  {{ $t('general.button.search') }}
                </button>
              </p>
            </div>
          </form>
          <div class="column is-narrow">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          icon="calendar-today"
                          @input="updateDateVisualisation"
                          :value="dateVisualisation"
                          :editable="true">
            </b-datepicker>
          </div>
        </div>
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permCatalogue.exporter"
            :action="exporter"/>
        </div>
      </div>
      <v-client-table :data="filteredFacesList"
                      class='mgt-10px column is-12
                      is-paddingless overflow-x-auto'
                      :columns="columns"
                      :options="options"
                      ref='tableRemises'>
        <template slot='afterTable'>
          <table-items-in-view @input="$refs.tableRemises.setLimit($event)"/>
        </template>
        <div slot="produit.reference" slot-scope="props" class="link">
          <router-link-blank
            :to="{ name: 'c.bodac.catalogue-face', params: { id: props.row.produitId }}"
            class="lien"
            :message="props.row.produit.reference">
          </router-link-blank>
        </div>
        <div slot="formatAffiche" slot-scope="props" class="link">
          <router-link-blank v-if="getFormatAffiche(props.row.produit.produitFace)"
            :to="{
              name: 'c.bodac.format_affiche',
              params: { id: getFormatAffiche(props.row.produit.produitFace).id }}"
            class="lien"
            :message="getFormatAffiche(props.row.produit.produitFace).code">
          </router-link-blank>
        </div>
        <div slot="reseauFaceTags" slot-scope="props">
          <tag-list :listes="getListeTags(props.row.reseauFaceTags)"/>
        </div>
        <div slot="dateDebut" slot-scope="props">
          {{ props.row.dateDebut | formatDate }}
        </div>
        <div slot="dateFin" slot-scope="props">
          {{ props.row.dateFin | formatDate }}
        </div>
        <div slot="montantTlpe" slot-scope="props" class="has-text-right">
          {{props.row.montantTlpe | formatDevise }}
        </div>
        <div slot="listeAffichage" slot-scope="props">
          {{ props.row.listeAffichage }}
        </div>
        <div slot="infoTlpe" slot-scope="props" class="has-text-centered">
          <a :class="{'pointer-events-none':
          getColorInfoTlpe(props.row.infoTlpe) === 'is-success'}"
             @click="openPopUpInfoTlpe(props.row)">
            <b-icon icon="circle" v-if="getColorInfoTlpe(props.row.infoTlpe)"
                    :type="getColorInfoTlpe(props.row.infoTlpe)"></b-icon>
          </a>
        </div>
        <template slot='appendBody' v-if="!isRegroupementLc">
          <table-footer-totaux
            ref="tableTotaux"
            :columns="columns"
            :target="targetTotal"
            :items="filteredFacesList">
          </table-footer-totaux>
        </template>
      </v-client-table>
    </div>
    <b-modal v-model="popUpInfoTlpe"
             has-modal-card
             class="modal">
      <pop-up-info-tlpe v-if="faceSelect"
                        :face="faceSelect.produit.reference"
                        :info="faceSelect.infoTlpe">
      </pop-up-info-tlpe>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { INFINITE_DAY } from '@/configuration/general';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import exportListeFacesToExcel from '@/services/excel/exportFace/exportListeFacesToExcel';
import { CATEGORIE_REGROUPEMENT_LC } from '@/configuration/catalogue/produitConf';
import { calculTlpeSemaineFaces } from '@/api/gabed/materiel';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import popUpInfoTlpe from '@/components/bodac/produit/reseauTempo/p_infoTlpe';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import { columnsSplice } from '@/services/general/columns';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import { createNamespacedHelpers } from 'vuex';
import tagList from '@/components/general/tagList';
import * as typesParametres from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    produit: Object,
    dateVisualisation: {
      type: Date,
      required: false,
    },
  },
  data() {
    return {
      filter: '',
      facesList: [],
      filterInput: '',
      permCatalogue: CATALOGUE,
      faceSelect: null,
      popUpInfoTlpe: false,
    };
  },
  components: {
    tagList,
    routerLinkBlank,
    TableItemsInView,
    popUpInfoTlpe,
    AppInformationMsgComponent,
    tableFooterTotaux,
    exportExcelButton,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    targetTotal() {
      return ['montantTlpe'];
    },
    isRegroupementLc() {
      return (this.produit.supportCommercial.categorieVente === CATEGORIE_REGROUPEMENT_LC);
    },
    moduleLogistiqueImpression() {
      const { moduleLogistiqueImpression } = typesParametres.PARAMETRES_INTERNE_KEYS;
      return this.parametresInterne(moduleLogistiqueImpression.key);
    },
    columns() {
      const columns = ['produit.reference', 'formatAffiche', 'produit.produitFace.format', 'produit.produitFace.materielType', 'adresse', 'produit.produitFace.adresse.codePostal', 'produit.produitFace.adresse.ville', 'reseauFaceTags', 'dateDebut', 'dateFin', 'montantTlpe', 'listeAffichage', 'infoTlpe'];
      if (this.isRegroupementLc) {
        columnsSplice(columns, 'montantTlpe');
        columnsSplice(columns, 'infoTlpe');
      }
      if (!this.moduleLogistiqueImpression) {
        columnsSplice(columns, 'formatAffiche');
      }
      return columns;
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      return {
        headings: {
          'produit.reference': this.$i18n.t('catalogue.table.face'),
          formatAffiche: this.$i18n.t('catalogue.table.formatAffiche'),
          'produit.produitFace.format': this.$i18n.t('catalogue.table.format'),
          'produit.produitFace.materielType': this.$i18n.t('catalogue.table.materiel'),
          adresse: this.$i18n.t('catalogue.table.adresse'),
          'produit.produitFace.adresse.codePostal': this.$i18n.t('catalogue.table.codePostal'),
          'produit.produitFace.adresse.ville': this.$i18n.t('catalogue.table.ville'),
          reseauFaceTags: this.$i18n.t('catalogue.table.reseauFaceTags'),
          dateDebut: this.$i18n.t('catalogue.table.startDate'),
          dateFin: this.$i18n.t('catalogue.table.endDate'),
          montantTlpe: this.$i18n.t('catalogue.table.montantTlpe'),
          listeAffichage: this.$i18n.t('catalogue.table.listeAffichage'),
          infoTlpe: '',
        },
        columnsClasses: {
          adresse: 'ellipsis address',
          infoTlpe: 'colonneSelected',
          reseauFaceTags: 'width-300px',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortIcon: SORT_ICON,
        sortable: [
          'produit.reference',
          'produit.produitFace.format',
          'produit.produitFace.materielType',
          'adresse',
          'produit.produitFace.adresse.codePostal',
          'produit.produitFace.adresse.ville',
          'dateDebut',
          'dateFin',
          'montantTlpe',
        ],
      };
    },
    filteredFacesList() {
      return this.facesList.filter(item => {
        const fields = [
          item.produit.reference,
          item.produit.produitFace.format,
          item.produit.produitFace.materielType,
          item.produit.produitFace.adresse.adresse1,
          item.produit.produitFace.adresse.adresse2,
          item.produit.produitFace.adresse.adresse3,
          item.produit.produitFace.adresse.codePostal,
          item.produit.produitFace.adresse.ville,
          item.dateDebut,
          item.dateFin,
        ];
        let find = false;
        const dateFin = item.dateFin ? moment(item.dateFin) : moment(INFINITE_DAY);
        if (!this.dateVisualisation
          || moment(this.dateVisualisation).isBetween(moment(item.dateDebut),
            dateFin, 'day', '[]')) {
          fields.forEach((field) => {
            if (field && field.toLowerCase().includes(this.filter.toLowerCase())) {
              find = true;
            }
          });
        }
        return find;
      });
    },
    getMessagesInfo() {
      return [{
        isLink: false,
        libelle: this.$i18n.t('detailProduitReseau.facesAssociesReseauMessage'),
      }];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    openPopUpInfoTlpe(faceSelect) {
      this.faceSelect = faceSelect;
      this.popUpInfoTlpe = true;
    },
    getColorInfoTlpe(infoTlpe) {
      if (!infoTlpe) return null;
      if (infoTlpe.messagesErreur.length > 0) return 'is-danger';
      return infoTlpe.messagesAvertissement.length > 0 ? 'is-warning' : 'is-success';
    },
    async updateDateVisualisation(newValue) {
      await this.$emit('editDateVisualisation', newValue);
      this.loadInfoTlpeFaces();
    },
    getListeTags(tags) {
      if (!tags.length) return [];
      return tags.map(t => t.tag);
    },
    getTagsLibelles(tags) {
      if (!tags.length) return [];
      return tags
        .map(t => t?.tag?.libelle || (typeof t.tag === 'string' ? t.tag : ''))
        .filter(Boolean)
        .join(', ');
    },
    exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const faces = this.facesList.filter((face) => {
          const dateFin = face.dateFin ? moment(face.dateFin) : moment(INFINITE_DAY);
          return moment(this.dateVisualisation).isBetween(moment(face.dateDebut), dateFin, 'day', '[]');
        });
        faces.forEach(face => {
          face.sousReseauExport = this.getTagsLibelles(face.reseauFaceTags);
        });
        exportListeFacesToExcel(faces, this.$i18n);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelFace.messages.excelExportError'));
        loadingComponent.close();
        throw e;
      }
    },
    loadInfoTlpeFaces() {
      try {
        if (!this.dateVisualisation) {
          this.facesList.forEach(item => {
            this.$set(item, 'montantTlpe', null);
            this.$set(item, 'infoTlpe', null);
          });
          return;
        }
        const params = {
          anneeSemaine: getAnneeSemaineFromDate(this.dateVisualisation),
          produitsFaces: this.filteredFacesList.map(face => face.produitId),
        };
        calculTlpeSemaineFaces(params)
          .then((rslt) => {
            this.facesList.forEach(item => {
              const resultFind = rslt.data.result.find((result) => {
                return result.produitId === item.produitId;
              });
              if (!resultFind) return;
              this.$set(item, 'infoTlpe', resultFind);
              this.$set(item, 'montantTlpe', resultFind.montant);
            });
          });
      } catch {
        this.facesList.forEach(item => {
          this.$set(item, 'montantTlpe', null);
          this.$set(item, 'infoTlpe', null);
        });
      }
    },
    async loadTourneeLigne() {
      const tourneeLigneWithFaceId = (
        await getAllTourneeLigne({
          query: {
            faceIds: this.filteredFacesList
              .filter(f => !!f.produit?.produitFace?.faceId)
              .map(f => f.produit.produitFace.faceId),
            societeId: this.societeActiveId,
          },
          limit: NO_PAGINATION,
        })
      ).data.result.items;
      this.filteredFacesList.forEach(item => {
        this.$set(item, 'listeAffichage', tourneeLigneWithFaceId.find(t => t.faceId
          === item.produit?.produitFace?.faceId)?.tournee?.libelle || null);
      });
    },
    getFormatAffiche(produit) {
      const formatAfficheId = produit.face?.materiel?.materielTechnique?.formatAfficheId;
      if (!formatAfficheId) {
        return null;
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.formatAffiche)
        .find((f) => {
          return f.id === formatAfficheId;
        });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.formatAffiche]);
      this.facesList = this.produit.produitReseau.affectationsReseauFace;
      this.facesList.forEach(item => {
        this.$set(item, 'adresse', adressFullStringGetter(item.produit.produitFace.adresse, true));
        this.$set(item, 'montantTlpe', null);
        this.$set(item, 'infoTlpe', null);
      });
      this.facesList.sort((a, b) => {
        if (a.produit.produitFace.adresse.ville < b.produit.produitFace.adresse.ville) return -1;
        if (a.produit.produitFace.adresse.ville > b.produit.produitFace.adresse.ville) return 1;
        if (a.produit.produitFace.adresse.ville === b.produit.produitFace.adresse.ville) {
          if (a.produit.produitFace.codeFace < b.produit.produitFace.codeFace) return -1;
          if (a.produit.produitFace.codeFace > b.produit.produitFace.codeFace) return 1;
        }
        return 0;
      });
      this.loadInfoTlpeFaces();
      this.loadTourneeLigne();
    } catch (err) {
      messageErreur(this.$i18n);
      throw err;
    } finally {
      loadingComponent.close();
    }
  },
};

</script>
